import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge the v2 scales, otherwise `text-ui-xs` is mistaken for a text colour and dropped when a colour class follows it.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["ui-2xs", "ui-xs", "ui-sm", "ui-base", "ui-md", "ui-lg", "ui-kpi"] }],
      "font-family": [{ font: ["ui", "display"] }],
      shadow: [{ shadow: ["card", "popover", "dialog"] }],
      rounded: [{ rounded: ["card", "sheet", "chip"] }],
      h: [{ h: ["ctl-sm", "ctl", "ctl-md", "ctl-touch", "row", "row-lg", "topbar"] }],
      w: [{ w: ["sidebar", "rail", "panel"] }],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
